import http from '@utils/http';

const basePath = '/api';

export const searchEvents = async (body) => {
  const data = await http.post(`${basePath}/events/search-equipments`, body);

  return data.data.data;
};
